import {Platform} from 'react-native';
import {store} from '../../redux';
import {showLoaderSlice} from '../../redux/reducers/loader/showLoader';
import {loaderTextSlice} from '../../redux/reducers/loader/loaderText';
import {blockingCallCountSlice} from '../../redux/reducers/httpWrapper/blockingCallCount';
import {clearLoadingState, saveLoadingState} from './loadingStateLocalStorage';

const DEFAULT_ESIA_LOADING_TEXT = 'ЗАГРУЗКА ДАННЫХ С ГОС УСЛУГ...';

type HideGlobalLoaderOptions = {
  resetBlockingCalls?: boolean;
};

export const showGlobalLoader = (text = DEFAULT_ESIA_LOADING_TEXT) => {
  store.dispatch(showLoaderSlice.actions.setShowing(true));
  store.dispatch(loaderTextSlice.actions.setText(text));
  if (Platform.OS === 'web') saveLoadingState(true, text);
};

export const hideGlobalLoader = ({resetBlockingCalls = false}: HideGlobalLoaderOptions = {}) => {
  store.dispatch(showLoaderSlice.actions.setShowing(false));
  store.dispatch(loaderTextSlice.actions.setText(''));
  if (resetBlockingCalls) {
    store.dispatch(blockingCallCountSlice.actions.reset());
  }
  if (Platform.OS === 'web') clearLoadingState();
};
